import React from 'react';
// import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import AddCircle from '@material-ui/icons/AddCircle';
import { hexToRgb } from '../common';
import Typography from '@material-ui/core/Typography';
import get from 'lodash/get';
import { SelectField } from './ejected/SelectField';
// import ContentView from '@material-ui/icons/Visibility';
// import { restClient } from '../common';


// const sanitizeRestProps = ({
//   addLabel,
//   allowEmpty,
//   basePath,
//   cellClassName,
//   className,
//   formClassName,
//   headerClassName,
//   label,
//   linkType,
//   locale,
//   record,
//   resource,
//   sortable,
//   sortBy,
//   source,
//   textAlign,
//   translateChoice,
//   ...rest
// }) => rest;

const AddClientButton = ({
  className,
  source,
  record,
  choices,
  optionValue,
  optionText,
  translate,
  translateChoice,
  create
}) => {
  const createButton = (fRecord) => (
    <IconButton
      color="inherit"
      onClick={create(true, fRecord)}
      style={{ maxWidth: '100%', height: '28px', width: '28px', color: '#7f7f7f' }}
    >
      <AddCircle style={{ width: '18px', height: '18px' }} />
    </IconButton>
  );
  if (!record.hasClient && record.visited === 'new') {
    const {
      fio: name, phone, subject_text, comment, id: customerId
    } = record;
    const sanitizedRecord = {
      name, phone, subject_text, comment, customerId
    };
    return createButton(sanitizedRecord);
  }

  const value = get(record, source);
  const choice = choices.find(c => c[optionValue] === value);
  if (!choice) return null;
  const choiceName = React.isValidElement(optionText) // eslint-disable-line no-nested-ternary
    ? React.cloneElement(optionText, { record: choice })
    : typeof optionText === 'function'
      ? optionText(choice)
      : choice[optionText];
  const { color } = choice;
  const rgb = hexToRgb(color);
  return (
    <Typography
      component="span"
      body1="body1"
      className={className}
    >
      <div style={{
        display: 'inline-block',
        position: 'relative',
        width: '9px',
        height: '9px',
        borderRadius: '50%',
        backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.5)`,
        marginRight: '9px'
      }}
      >
        <div style={{
          position: 'absolute',
          top: '2px',
          left: '2px',
          display: 'inline-block',
          width: '5px',
          height: '5px',
          borderRadius: '50%',
          backgroundColor: color,
        }}
        />
      </div>
      <span style={{ color: choice.color }}>
        {choiceName}
      </span>
    </Typography>
  );
};

AddClientButton.defaultProps = {
  record: {},
  optionText: 'name',
  optionValue: 'id'
};

AddClientButton.propTypes = {
  create: PropTypes.func,
  record: PropTypes.object,
  className: PropTypes.string,
};


export default AddClientButton;



// WEBPACK FOOTER //
// ./src/components/AddClientButton.js